/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Link_Display_NameInputs */

const en_tables_rule_sets_link_display_name = /** @type {(inputs: Tables_Rule_Sets_Link_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Link Display Name`)
};

const de_tables_rule_sets_link_display_name = /** @type {(inputs: Tables_Rule_Sets_Link_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angezeigter Name`)
};

/**
* | output |
* | --- |
* | "Sets Link Display Name" |
*
* @param {Tables_Rule_Sets_Link_Display_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_link_display_name = /** @type {((inputs?: Tables_Rule_Sets_Link_Display_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Link_Display_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_link_display_name(inputs)
	return de_tables_rule_sets_link_display_name(inputs)
});